import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaiementSuccesPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/apprenant'), 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
        <span className="text-3xl text-green-600">✓</span>
      </div>
      <h1 className="text-2xl font-semibold text-slate-800">Paiement confirmé !</h1>
      <p className="text-slate-600">Votre inscription est validée. Redirection vers votre espace...</p>
    </div>
  );
};

export default PaiementSuccesPage;